import React from 'react';
import { useStore } from '../../../../store/rootStore';
import QuickReplyPreview from '../shared/QuickReplyPreview';
import styles from './QuickReply.module.scss';
const QuickReply = ({ quickReply, departmentsList, onClicked }) => {
    const { activeChatStore } = useStore();
    if (!activeChatStore.chat)
        return null;
    return (React.createElement(QuickReplyPreview, { quickReply: quickReply, className: styles.quickReplyMessage, messageClassName: styles.quickReplyMessagePreview, onClick: onClicked }));
};
export default QuickReply;
